import { init as internalInit } from './analytics/init.js';
import { track as internalTrack } from './analytics/track.js';
import { updateGlobalActionProperties as updateGlobalActionPropertiesInternal } from './analytics/globalActionProperties.js';
import { identify as internalIdentify, getUserTraits as getUserTraitsInternal } from './analytics/identify.js';
import { alias } from './analytics/alias.js';
/**
 * Used to initialize the analytics client. Should be called once when loading the application.
 */
export function init(config) {
    internalInit(config);
}
export function track(action) {
    internalTrack(action);
}
// Moving from the cleaner export to this format, mainly to avoid fighting typdoc generation
// TODO - we can come back to this post release to yak shave typedoc
export const identify = internalIdentify;
export const updateGlobalActionProperties = updateGlobalActionPropertiesInternal;
export const getUserTraits = getUserTraitsInternal;
export default { init, track, identify, updateGlobalActionProperties, alias, getUserTraits };
//# sourceMappingURL=analytics.js.map